import '../../css/pages/live_detail.less'
import '../../css/pages/live_detail_6.less'
import '../../css/pages/live_detail_8.less'
import '../../css/pages/live_detail_9.less'  // 上科定制
import { npuEventStatistics, getCourseTypeInfo } from './utils/npuTracker'
var liveAddress = []
if (liveType == 'activity') {
    liveAddress = info.liveAddress || []
} else {
    liveAddress = liveAddressFormat(info.videoUrl, info.id)
    liveAddress = liveAddress.filter(el => {
        return el.stream_address
    })
}

liveAddress = liveAddress.map((el, index) => {
    return { ...el, index }
})
new Vue({
    el: '#app',
    data: function () {
        const validatePass = (rule, value, callback) => {
            API.reqValidateLivePassword({ liveId: info.id, passWord: value }).then(res => {
                if (res.status == 200 && res.data) {
                    callback()
                } else {
                    callback(new Error('密码错误！'))
                }
            }).catch(err => callback(new Error('密码错误！')))
        }
        this.statisticsInterval = null
        return {
            bannerPlateType,
            roomId,
            info,
            courseId: info.id,
            rightActiveTab: '1',
            voiceTextStatus: false,
            noteData: {},
            noteContent: '',
            liveInfo: {},//当前直播信息
            liveAddress,
            liveType,
            middleVoice: '',
            scheduleStatus: info.scheduleStatus,//1-未开始，2-直播中，3-回看，4-已结束
            showMiniScreen: true,
            noteLength: 0,
            notePanelInfo: {
                courseId: info.id,
                courseName: info.liveName,
                cover: (info.liveCover != 'null' && info.liveCover) ? info.liveCover : '/learn/static/imgs/live_default_cover.png',
                noteType: 'live-' + liveType,
                note: "",
                pointOut: 0,
                remark: "",
                ready: true,
                defaultImage: (info.liveCover != 'null' && info.liveCover) ? info.liveCover : '/learn/static/imgs/live_default_cover.png'
            },
            //课程直播教师列表展开标识
            teacherExpand: false,
            teacherExpandActive: true,
            password: '',
            passwordModalVisible: false,
            validatePasswordResolve: null,
            passwordForm: {},
            passwordRules: {
                password: [{
                    required: true,
                    message: '请输入密码',
                    trigger: 'blur'
                }, {
                    required: true,
                    trigger: 'blur',
                    //validatePass --- 我们自定义的校验规则
                    validator: validatePass
                }]
            },
            headActive: true,
            scrollNavStatus: true,//开启页面滚动监听控制导航样式
            player: null,
            wsId: '',//语音转写wsId
            voiceRouteList: [],//后台配置的语音转写流列表
            ifAdmin,//是否管理端内嵌页面
            likeParam: {
                courseId: info.id,
                courseName: info.liveName,
                courseType: 3
            },
            showTabs: {
                ppt: false
            },
            player_sound_source_hide: false,//隐藏声音源
            hasLookBackVideo: false,//是否有回看视频
            voiceTranslate: false,
            liveTextTrackDelay: 0,//直播字幕延迟
            watermarkPictureUrl: '',//播放器版权水印图片
            watermarkLocation: 0,//播放器版权水印位置0-左上,1-左下,2-右上,3-右下
            ifSys: false,//是否系统管理员
        }
    },
    watch: {
        rightActiveTab: {
            handler(newVal) {
                if (newVal == '3') {
                    this.$nextTick(() => {
                        this.$refs.liveInteraction && this.$refs.liveInteraction.scrollToBottom()
                    })
                }
            }
        },
    },
    computed: {
        isMute() {
            return this.liveInfo.is_mute
        },
        speakerInfo() {
            if (liveType == 'activity') {
                return {
                    name: info.liveSpeaker,
                    code: info.speakerId,
                }
            } else {
                return {
                    name: info.teacherName,
                    code: info.teacherId
                }
            }
        }
    },
    async mounted() {
        //选中直播导航
        if (document.querySelector(".nav_view .menu_view a[href='/learn/live']")) document.querySelector(".nav_view .menu_view a[href='/learn/live']").className = 'tab_active'
        const that = this
        this.$on('ready', async () => {
            this.ifSys = this.loginUserInfo?.roles?.includes("r_sys_manager")
            this.liveTextTrackDelay = that.sysModulesObj.live_text_rack_delay || 30
            // console.log(this.loginUserInfo)
            that.initActiveTab()
            //是否隐藏音源切换
            that.player_sound_source_hide = that.sysModulesFormat.includes('player_sound_source_hide')
            if (!that.sysModulesFormat.includes('live_note_display')) {
                that.initActiveTab()
                if (!that.sysModulesFormat.includes('live_voice_text_display')) {
                    that.initActiveTab()
                }
            }
            let hasPermission = await this.getPermission()
            if (!hasPermission) {
                if (!this.loginUserInfo || !Object.keys(this.loginUserInfo).length) {
                    location.replace(this.loginHref)
                }
                return
            }
            if (info.scheduleStatus == 2 || info.taskStatus == 2) {
                this.liveInit(this.liveAddress)
            } else if (info.lookBack && info.scheduleStatus == 3) {
                //开启了回看且直播已结束
                //查询直播回看资源是否生成完成
                let seatList = []
                API.reqLiveBackResource({
                    folderId: "",
                    folderPath: "global_sobey_defaultclass/",
                    sortFields: [
                        {
                            field: "createDate_",
                            isDesc: true
                        }
                    ],
                    pageIndex: 1,
                    pageSize: 50,
                    conditions: [
                        {
                            field: "type_",
                            searchRelation: 0,
                            value: [
                                "biz_sobey_video"
                            ]
                        },
                        {
                            field: "activity_live_id",
                            searchRelation: 0,
                            value: [info.id]
                        }
                    ]
                }).then(res => {
                    if (res.success && res.data?.data?.length) {
                        seatList = res.data?.data?.map(el => el.seat)
                        return Promise.all(res.data?.data?.map(el => API.reqVideoDetail(el.contentId_)))
                    } else {
                        //回看生成中
                        this.initLiveBack([])
                        this.$message.warning('回看生成中！')
                    }
                }).then(resArr => {
                    let address = resArr.map((res, index) => {
                        let path
                        if (res.success && res.data) {
                            path = res.data.fileGroups?.find(el => el.typeCode == 'previewfile')?.fileItems[0]?.filePath
                        }
                        return {
                            name: seatList[index],
                            path
                        }
                    }).filter(el => el.path)
                    if (address.length) {
                        //回看视频
                        this.hasLookBackVideo = true
                        this.$nextTick(() => this.initLiveBack(address))
                    } else {
                        this.initLiveBack([])
                        this.$message.warning('回看生成中！')
                    }
                }).catch((err) => {
                    console.error('查询回看失败', err)
                    //回看生成中
                    this.initLiveBack([])
                    this.$message.warning('回看生成中！')
                })
                return
            }
            // this.getNote()
            //有多个直播列表展示列表
            // if (this.liveAddress.length > 1) {
            //     this.rightActiveTab = '0'
            // }
            this.heartBeat()
            //轮询直播状态
            setInterval(function interval() {
                that.pollLiveStatus()
                return interval
            }(), 5000)
            window.addEventListener("scroll", () => this.scrollHandle())
            this.initTeacherListExpand()
            window.addEventListener('resize', function () {
                if (that.prevenWidth > 768 && window.innerWidth <= 768) {
                    //pc变移动端
                    setTimeout(() => {
                        that.initActiveTab()
                    }, 500);
                } else if (that.prevenWidth <= 768 && window.innerWidth > 768) {
                    //移动端变pc
                    setTimeout(() => {
                        that.initActiveTab()
                    }, 500);
                }
                that.prevenWidth = window.innerWidth

            })
            this.initPermission()
            this.statisticsWatchTime()
        })
        this.getConcernStatus()
        window.addEventListener('beforeunload', function (e) {
            //西工大统计-取消观看直播、录播
            npuEventStatistics({
                eventCode: this.isLiveBack ? 'notView_liveStreaming' : 'notView_liveStreaming',
                eventOpeartionObjectCatelogName: this.isLiveBack ? '录播' : liveType == 'activity' ? '活动直播' : '课程直播',
                eventOpeartionObjectCatelogCode: this.isLiveBack ? 'video_review' : ('live_' + liveType),
                eventOpeartionObjectName: info.liveName,
                eventOpeartionObjectCode: info.id,
                eventOpeartionObjectDetail: '观看' + this.isLiveBack ? '回看' : '直播' + info.liveName,
            })
        });
    },
    beforeDestroy() {
        window.removeEventListener("scroll", () => this.scrollHandle())
    },
    methods: {
        //活动直播统计观看时长
        statisticsWatchTime() {
            const that = this
            if (this.statisticsInterval) {
                clearInterval(this.statisticsInterval)
                this.statisticsInterval = null
            }
            this.statisticsInterval = setInterval(() => {
                if (liveType != 'activity' || !that.loginUserInfo || !Object.keys(that.loginUserInfo).length || !that.player || that.player.status != 1 || !that.sysModulesFormat.includes('activity_live_statistics_watch_time')) {
                    return
                }
                API.reqLiveStatisticsWatchTime({
                    liveId: info.id,
                    liveName: info.liveName || info.courseName,
                    studentCode: this.loginUserInfo.user_code,
                    watchDuration: 10
                }).then()
            }, 1000 * 10)
        },
        initActiveTab() {
            const that = this
            this.$nextTick(() => {
                let tabsRef = this.$refs.rightTabsRef.panes
                if (tabsRef && tabsRef.length) {
                    setTimeout(() => {
                        //.3秒动画完成后再切换，否则会错位
                        that.rightActiveTab = tabsRef[0].name
                    }, 1000);
                }
            })
        },
        initPermission() {
            if (this.loginUserInfo) {
                if (info.lookPermission == 'school') {
                    this.validatePasswordResolve && this.validatePasswordResolve(true)
                    this.validatePasswordResolve = null
                }
            }
        },
        scrollHandle() {
            if (jQuery(document).scrollTop() > 550 && this.showMiniScreen) {
                if (jQuery("#h5player").has(".xgplayer-miniplayer-lay").length === 0) {
                    this.player.getMiniplayer()
                    jQuery(".xgplayer-miniplayer-lay").hide()
                    jQuery(".mini_window").show()
                    jQuery(".xgplayer-miniplayer-active").append("<div class='icon'>×</div>")
                    jQuery("#h5player .icon").click(() => {
                        this.player.exitMiniplayer()
                        jQuery(".mini_window").hide()
                        jQuery("#h5player .icon").remove()
                        this.showMiniScreen = false
                    })
                }

            } else {
                if (jQuery("#h5player").has(".xgplayer-miniplayer-lay").length > 0) {
                    this.player.exitMiniplayer()
                    jQuery(".mini_window").hide()
                    jQuery("#h5player .icon").remove()
                }
                setTimeout(() => {
                    this.showMiniScreen = true
                }, 200)
            }
        },
        playerInit(urls, isLive) {
            let that = this
            urls = urls || []
            if (that.player) {
                try {
                    that.player.pause();
                    that.player.flv && that.player.flv.destroy();
                    that.player.hls && that.player.hls.destroy();
                    that.player && that.player.destroy();
                } catch (err) {
                    // console.error('注销失败！' + err);
                }
                that.player = null;
            }
            var option = {
                id: 'h5player',
                isLive: !this.hasLookBackVideo,//非直播回看为直播
                playsinline: true,
                urls,
                autoplay: true,
                volume: localStorage.getItem('VIDEO_VOLUME') || 0.6,
                // controls: !muted,
                pip: true,
                fluid: true,
                // fitVideoSize: 'auto',
                // width: 884,
                // height: 610,
                miniplayerConfig: {
                    bottom: 50,
                    right: 0,
                    width: 320,
                    height: 180
                },
                screenShot: {
                    saveImg: true,
                    quality: 0.92,
                    type: 'image/png',
                    format: '.png',
                },
                errorTips: '错误',
                flvOptionalConfig: {
                    fixAudioTimestampGap: false, //填充静默音频帧以避免检测大音频时间戳间隙时A / V Unsync。
                    enableWorker: true, // 是否多线程工作
                    enableStashBuffer: true, //启用IO Stash缓冲区。 如果您需要实时（最小延迟），则设置为false，但如果有网络抖动可能会停止
                    stashInitialSize: 128 * 40, // 缓存大小(kb)  默认384kb 128kb
                    reuseRedirectedURL: true, //重用301/302重定向url，用于随后的请求，如查找、重新连接等。
                    autoCleanupSourceBuffer: true, //自动清除缓存
                },
                danmu: {},//开启弹幕
                preload: !this.sysModulesFormat.includes('player_preload_off'),
                version: 3,
                display: (this.sysModules.find(item => item.code == 'multi_view_player_display') || {}).value || 1,
                //直播字幕配置
                // textTrack: info.kto.map(el=>({
                //     label: el.name,
                //     srclang: el.code,
                //     default: false
                // })),
            }
            if (this.sysModulesFormat.includes('player_all_show_watermark')) {
            }
            option.watermark = that.loginUserInfo?.nick_name ? `${that.loginUserInfo.nick_name}，${that.loginUserInfo.user_code}` : ''
            if (option.urls && option.urls.length) {
                let url = option.urls[0].path
                if (url.split('?')[0].includes('.flv')) {
                    option.rmvb = 'flv'
                } else if (url.split('?')[0].includes('.m3u8')) {
                    option.rmvb = 'm3u8'
                }
            }
            //自定义直播画面名称
            let live_custom_screen_name = this.sysModules.find(item => item.code == 'live_custom_screen_name')
            if (live_custom_screen_name) {
                try {
                    live_custom_screen_name = JSON.parse(live_custom_screen_name.value)
                    if (Object.keys(live_custom_screen_name).length) {
                        option.urls.map((u, i) => {
                            if (!!live_custom_screen_name[u.name]) {
                                u.name = live_custom_screen_name[u.name]
                            }
                        })
                    }
                } catch { }
            }
            //默认开启画面
            let defaultFrame = []
            let sortFrame = []
            let excludeFrame = []
            if (liveType == 'activity') {
                // console.log('活动直播排序', this.sysModules.find(item => item.code == 'activity_live_screen_sort'))
                defaultFrame = ((this.sysModules.find(item => item.code == 'default_activity_live_screen') || {}).value || '').split(/[,|，]/)
                sortFrame = ((this.sysModules.find(item => item.code == 'activity_live_screen_sort') || {}).value || '').split(/[,|，]/)
                excludeFrame = ((this.sysModules.find(item => item.code == 'activity_live_screen_exclude') || {}).value || '').split(/[,|，]/)
            } else {
                defaultFrame = ((this.sysModules.find(item => item.code == 'default_course_live_screen') || {}).value || '').split(/[,|，]/)
                sortFrame = ((this.sysModules.find(item => item.code == 'course_live_screen_sort') || {}).value || '').split(/[,|，]/)
                excludeFrame = ((this.sysModules.find(item => item.code == 'course_live_screen_exclude') || {}).value || '').split(/[,|，]/)
            }
            //画面过滤
            if (excludeFrame && excludeFrame.length) {
                option.urls = option.urls.filter(u => !excludeFrame.find(d => u.name.includes(d)))
            }
            //画面排序
            if (sortFrame && sortFrame.length) {
                option.urls = [...option.urls].sort((a, b) => {
                    if (sortFrame.indexOf(a.name) === -1) return 99
                    return sortFrame.indexOf(a.name) - sortFrame.indexOf(b.name)
                }).slice(-4)
            }
            if (defaultFrame && defaultFrame.length) {
                let arr = []
                option.urls.map((u, i) => {
                    if (!!defaultFrame.find(d => u.name.includes(d))) {
                        arr.push(i + 1)
                    }
                })
                option.defaultFrame = arr
            }
            //默认开启音源
            let defaultAudio = []
            if (liveType == 'activity') {
                defaultAudio = ((this.sysModules.find(item => item.code == 'default_activity_live_audio') || {}).value || '').split(/[,|，]/)
            } else {
                defaultAudio = ((this.sysModules.find(item => item.code == 'default_course_live_audio') || {}).value || '').split(/[,|，]/)
            }
            if (defaultAudio && defaultAudio.length) {
                let arr = []
                option.urls.map((u, i) => {
                    if (!!defaultAudio.find(d => u.name.includes(d))) {
                        arr.push(i + 1)
                    }
                })
                option.defaultAudio = arr
            }
            if (that.sysModulesFormat.includes('live_interaction_off')) {
                delete option.danmu
            }
            console.log('option', option)
            that.player = new MultiViewPlayer(option)
            // that.player.videoId = info.id
            that.player.on(
                'error',
                (errType, errDetail, errInfo) => {
                    // alert("网络波动,正在尝试连接中...");
                    console.log('errType:', errType);
                    console.log('errDetail:', errDetail);
                    console.log('errInfo:', errInfo);
                    console.log('网络波动,正在尝试连接中...');
                    // if (that.player) {
                    //     //reloadVideo();
                    //     init_player($video); //重连
                    // }
                    // errType是 NetworkError时，对应errDetail有：Exception、HttpStatusCodeInvalid、ConnectingTimeout、EarlyEof、UnrecoverableEarlyEof
                    // errType是 MediaError时，对应errDetail是MediaMSEError   或MEDIA_SOURCE_ENDED
                }
            );

            that.player.on('volumechange', (res) => {
                localStorage.setItem('VIDEO_VOLUME', (res.volume || 0.6))
            })

            that.player.on('statistics_info', function (res) {
                if (res.playerType == 'HlsPlayer' || that.lastDecodedFrame == 0) {
                    that.lastDecodedFrame = res.decodedFrames;
                    return;
                }
                if (that.lastDecodedFrame != res.decodedFrames) {
                    that.lastDecodedFrame = res.decodedFrames;
                    that.lastCurrentTime = that.player.currentTime; //最后的时间
                    that.sameCount = 0;
                } else {
                    that.sameCount++;
                    if (that.sameCount > 25) {
                        //decodedFrames 25 次不变，则判断为画面卡死，销毁实例进行重连
                        //.log('画面解码延迟，次数:', that.sameCount, '时间', new Date());
                        that.lastDecodedFrame = 0;
                        that.sameCount = 0;

                        if (that.player) {
                            that.currentTime = 0;
                            that.lastCurrentTime = 0;
                            //console.log('init_player');
                            //init_player($video); //重连
                        }
                    }
                }
                //console.log("最后的时间：", that.lastCurrentTime, "   10秒前的时间：", that.currentTime);
            });
            // that.player.emit('resourceReady', [
            //     {name: '超清', url},
            //     {name: '高清', url},
            // ]);
            that.player.on('error', function (error) {
                console.error(error);
            });

            that.player.on('change', function (players) {
                // console.log(players)
                let showVoiceList = players.filter(p => p.ifShow).map(p => p.urlInfo.path) //过滤出显示了画面的流地址
                let voiceUrlInfo = that.voiceRouteList.find(el => showVoiceList.includes(el.stream_address)) //过滤出设置了语音的并且显示了画面的流地址
                if (voiceUrlInfo && that.voiceUrlInfo.stream_address != voiceUrlInfo.stream_address) { //切换了语音流地址
                    that.voiceUrlInfo = voiceUrlInfo
                    // console.log('切换了语音流地址',that.voiceUrlInfo)
                    if (that.voiceTextStatus) {
                        //开启了语音转写的需要重新开启
                        that.voiceToTextChangeHandle(true)
                        if (that.voiceTranslate) {
                            //开启了同声传译的需要重新开启
                            that.handleVoiceTranslateOpen(true)
                        }
                    }
                }
            })
            //西工大统计-观看直播、录播
            npuEventStatistics({
                eventCode: this.isLiveBack ? 'view_liveStreaming' : 'view_liveStreaming',
                eventOpeartionObjectCatelogName: this.isLiveBack ? '录播' : liveType == 'activity' ? '活动直播' : '课程直播',
                eventOpeartionObjectCatelogCode: this.isLiveBack ? 'live_review' : ('live_' + liveType),
                eventOpeartionObjectName: info.liveName,
                eventOpeartionObjectCode: info.id,
                eventOpeartionObjectDetail: '观看' + this.isLiveBack ? '回看' : '直播' + info.liveName,
            })
        },
        setVideoError(text) {
            if (this.player) {
                this.player.pause()
                this.player.config.errorTips = text
                this.player.emit('error')
            }
        },
        downloadNote() {
            const urlObject = window.URL || window.webkitURL || window;
            const export_blob = new Blob([this.noteContent]);
            const save_link = document.createElementNS(
                'http://www.w3.org/1999/xhtml',
                'a'
            );
            save_link.href = urlObject.createObjectURL(export_blob);
            save_link.download = '笔记';
            const ev = document.createEvent('MouseEvents');
            ev.initMouseEvent(
                'click',
                true,
                false,
                window,
                0,
                0,
                0,
                0,
                0,
                false,
                false,
                false,
                false,
                0,
                null
            );
            save_link.dispatchEvent(ev);
        },
        pauseHandle() {
            this.player.pause().then(res => {
                console.log(res)
            })
        },
        addNoteHandel() {
            this.$set(this.noteData, 'editActive', true)
        },
        saveNote() {
            if (this.noteContent == this.noteData.remark) return
            debugger
            API.reqSensitiveWord(this.noteContent, '笔记', () => API.reqCourseNoteUpdate({ ...this.noteData, remark: this.noteContent })).then(res => {
                this.$message.success('笔记更新成功')
                this.noteData.remark = this.noteContent
            })
        },
        liveInit(liveArr) {
            // if (live == this.liveInfo) return
            // this.liveInfo = live
            // this.liveInfo = liveArr[0] || {}
            this.voiceRouteList = liveArr.filter(el => el.voice_identify)
            // console.log(liveArr)
            // this.playerInit(liveArr.map(el => ({ path: el.stream_address, name: el.stream_name })))
        },
        initLiveBack(urls) {
            this.isLiveBack = true
            this.playerInit(urls, false)
        },
        heartBeat() {
            setInterval(() => {
                API.reqHeartBeat().then()
            }, 1000 * 60 * 5)
        },
        async pollLiveStatus() {
            const that = this
            let status = 0
            let res = null
            if (liveType == 'activity') {
                //活动直播
                res = await API.reqActivityLiveInfo({ live_id: this.courseId })
            } else {
                //课程直播
                res = await API.reqCourseLiveInfo({ live_id: this.courseId })
                res.data.scheduleStatus = res.data.taskStatus
            }
            if (!res || res.status != 200) return
            const { scheduleStatus } = res.data
            this.scheduleStatus = scheduleStatus
            if (scheduleStatus == 2) {
                //直播中
                that.$nextTick(() => {
                    if (!that.player) {
                        let arr = this.liveAddress.map(el => ({
                            id: el._id,
                            path: el.stream_address,
                            name: el.stream_name,
                            is_select: el.is_select ?? true,
                            // muted: el.is_mute === 'true',
                            muted: false,
                            pull: el.pull_url,
                            push: el.push_url
                        }))
                        if (liveType == 'activity') {
                            arr = arr.filter(j => j.is_select)
                        }
                        that.playerInit(arr)
                    }
                })
            } else {
                //未开始或已结束
                try {
                    that.player.destroy()
                } catch (err) {
                }
                that.player = null
            }
        },
        initTeacherListExpand() {
            this.$nextTick(() => {
                if (liveType == 'course') {
                    //课程直播教师为列表，做换行展开处理
                    // console.log(jQuery('.teahcer_list').height())
                    if (jQuery('.teahcer_list').height() > 70) {
                        this.teacherExpand = true
                        this.teacherExpandActive = false
                    }
                }
            })
        },
        passwordConfirm(e) {
            const that = this
            this.$refs.passwordForm.validate((valid) => {
                if (valid) {
                    that.validatePasswordResolve(true)
                    that.validatePasswordResolve = null
                    that.passwordModalVisible = false
                }
            });
        },
        getPermission() {
            const that = this
            return new Promise((resolve) => {
                that.validatePasswordResolve = resolve
                if (!info.lookPermission) return resolve(true) //课程直播无权限设置
                if (that.ifAdmin) return resolve(true) //管理端嵌入直接可进入
                if (info.lookPermission == 'public') {
                    //社会公开
                    resolve(true)
                } else {
                    if (!that.hasLogin) return location.replace(this.loginHref)
                }
                if (info.lookPermission == 'school') {
                    //校内公开
                    if (that.loginUserInfo) {
                        resolve(true)
                    } else {
                        that.$message.info('请登录！')
                    }
                } else if (info.lookPermission == 'password') {
                    //需要密码进入
                    that.passwordModalVisible = true
                }
            })
        },
        //直播预约
        handleReservation() {
            if (!this.loginUserInfo) return location.replace(this.loginHref)
            API.reqLiveReservation({ live_id: info.id, live_type: liveType == 'activity' ? 0 : 1 }).then(res => {
                if (res.error_code == 'livemanage.0000.0000') {
                    this.$message.success('预约成功！')
                    this.info.isReservation = true
                }
                npuEventStatistics({
                    eventCode: 'reserve_liveStreaming',
                    eventOpeartionObjectCatelogName: liveType == 'activity' ? '活动直播' : '课程直播',
                    eventOpeartionObjectCatelogCode: 'live_' + liveType,
                    eventOpeartionObjectName: info.liveName,
                    eventOpeartionObjectCode: info.id,
                    eventOpeartionObjectDetail: '预约直播' + info.liveName,
                    eventOpeartionResult: res.error_code == 'livemanage.0000.0000' ? '成功' : '失败'
                })
            })
        },
        //直播取消预约
        handleReservationCancel() {
            API.reqLiveReservationCancel({ live_id: info.id, live_type: liveType == 'activity' ? 0 : 1 }).then(res => {
                if (res.error_code == 'livemanage.0000.0000') {
                    this.$message.success('取消预约成功！')
                    this.info.isReservation = false
                }
                npuEventStatistics({
                    eventCode: 'notReserve_liveStreaming',
                    eventOpeartionObjectCatelogName: liveType == 'activity' ? '活动直播' : '课程直播',
                    eventOpeartionObjectCatelogCode: 'live_' + liveType,
                    eventOpeartionObjectName: info.liveName,
                    eventOpeartionObjectCode: info.id,
                    eventOpeartionObjectDetail: '取消预约直播' + info.liveName,
                    eventOpeartionResult: res.error_code == 'livemanage.0000.0000' ? '成功' : '失败'
                })
            })
        },
        //直播互动更新
        onInteractionUpdate(arr) {
            //显示弹幕
            this.player?.danmu?.updateComments(arr.map(el => ({
                duration: 15000,
                id: el.id,
                // start: 3000, //不提供该项则立即发送
                txt: el.text,
                style: {
                    color: '#ff9500',
                    fontSize: '16px',
                    border: 'solid 1px #fff',
                    borderRadius: '50px',
                    padding: '5px 11px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
            })))
        },
        //获取主讲人关注状态
        getConcernStatus() {
            if (!this.loginUserInfo) return
            if (liveType == 'activity') {
                //活动直播
                API.reqIsFans([info.speakerId]).then(res => {
                    if (res.status == 200) {
                        this.info.isFans = res.data[0].isFans
                    }
                })
            } else {
                //课程直播
                API.reqIsFans(info.teacherInfo.map(el => el.code)).then(res => {
                    if (res.status == 200) {
                        this.info.teacherInfo = this.info.teacherInfo.map((el, i) => ({
                            ...el,
                            isFans: res.data[i].isFans
                        }))
                    }
                })
            }
        },
        //关注
        handleConcern(e, userCode, type) {
            if (!this.loginUserInfo) return this.$message.info(this.$t('请登录！'))
            const dom = jQuery(e.currentTarget).parent()
            if (type) {
                //添加关注
                API.reqFollowOrCancel({ userCode }).then(res => {
                    // console.log(res)
                    if (res.status == 200) {
                        dom.addClass('active')
                        this.$message.success(this.$t('关注成功'))
                    } else {
                        this.$message.error(res.message)
                    }
                    this.npuCollectStatistics({ code: 'follow_teacher', success: res.status == 200 })
                })
            } else {
                //取消关注
                API.reqFollowOrCancel({ userCode }).then(res => {
                    // console.log(res)
                    if (res.status == 200) {
                        dom.removeClass('active')
                        this.$message.success(this.$t('取消关注成功'))
                    }
                    this.npuCollectStatistics({ code: 'notFollow_teacher', success: res.status == 200 })
                })
            }

        },
        //开启或关闭同声传译
        handleVoiceTranslateOpen() {
            if (!this.voiceTranslate) {
                this.$refs.voice_translate.handleVoiceTranslateOpen()
            } else {
                this.$refs.voice_translate.handleVoiceTranslateClose()
            }
        },
        npuCollectStatistics(option) {
            const { code, success } = option
            const { courseTypeName, courseTypeCode } = getCourseTypeInfo()
            //西工大统计-关注、取消关注教师
            npuEventStatistics({
                eventCode: code,
                eventOpeartionObjectCatelogName: courseTypeName,
                eventOpeartionObjectCatelogCode: 'live_' + courseTypeCode,
                eventOpeartionObjectName: info.liveSpeaker || info.teacherName,
                eventOpeartionObjectCode: info.speakerId || info.teacherId,
                eventOpeartionObjectDetail: (code == 'collect_course' ? '关注' : '取消关注') + info.liveSpeaker || info.teacherName,
                eventOpeartionResult: success ? '成功' : '失败'
            })
        },
        ifShowPpt() {
            this.showTabs.ppt = true;
            this.initActiveTab()
        },
        //获取周跨度
        getWeekSpan(str) {
            let arr = JSON.parse(str || "[]")
            if (arr.length > 1) {
                return arr[0] + '-' + arr[arr.length - 1] + '周'
            } else if (arr.length) {
                return arr[0] + '周'
            } else {
                return ''
            }
        },
        //播放器版权水印
        initPlayerWatermark() {
            API.reqPlayerWatermark().then(res => {
                if (res.errorCode == 'success' && res.extendMessage && res.extendMessage.length) {
                    const data = res.extendMessage[0]
                    const { watermarkModule = [], watermarkLocation, watermarkPictureUrl } = data
                    if (watermarkModule.includes(0)) {
                        this.watermarkPictureUrl = watermarkPictureUrl
                        this.watermarkLocation = watermarkLocation
                    }
                }
            })
        },
        handleCloseVoiceService() {
            API.reqLiveVoiceToTextClose({
                live_list: [{ live_id: info.id }]
            }).then(res => {
                if (res.status == 200) {
                    if (res.data.success_list) {
                        this.$message.success('关闭成功')
                    } else {
                        this.$message.warning('未开启语音服务')
                    }
                } else {
                    this.$message.error('关闭失败')
                }
            })
        }
    }
})
